mutation confirmMigrationWallet($wallet_type: String, $eth_address: String, $email: String, $hash: String, $user_id: String) {
    confirmMigrationWallet(wallet_type: $wallet_type, eth_address: $eth_address, email: $email, hash: $hash, user_id: $user_id)
}
